import { createFeatureSelector, createSelector } from '@ngrx/store';
import { memoize } from 'lodash';
import { GenesysCloudCobrowseState } from '../genesys-cobrowse.state';
import { featureKey } from '../reducers/feature-key';

export const selectState = createFeatureSelector<GenesysCloudCobrowseState>(featureKey);

export const selectCobrowseActive = memoize((conversationId: string) =>
  createSelector(selectState, (state) => state[conversationId.toString()])
);
